/*
 * Employee List
 */

import React from "react";
import { useState, useEffect } from "react";
import MetaTags from "react-meta-tags";
import { useDispatch, useSelector } from "react-redux";
import {
  Col,
  Row,
  Button,
  Select,
  DatePicker,
  Table,
  Tag,
  Checkbox,
  Input,
  Typography,
} from "antd";
import {
  FilterOutlined,
  ReloadOutlined,
  DownloadOutlined,
  SearchOutlined,
} from "@ant-design/icons";

import "../Dashboard/index.css";
import "../EmployeeManagement/index.css";
import { isEmpty } from "lodash";
import BreadcrumbComponent from "../../components/BreadCrumb";
import * as employeeListAction from "../../store/Reports/actions";
import api from "../../helpers";
import moment from "moment";

const BCrumb = [{ to: "/", title: "Home" }, { title: "Employee List" }];

const EmployeeList = () => {
  const [downloadLoader, setDownloadLoader] = useState(false);

  // const [searchLoading, setSearchLoading] = useState(false);
  const [resetLoading, setResetLoading] = useState(false);

  //filter initial data
  const [employeeList, setEmployeeList] = useState({
    joinFromDate: "",
    joinToDate: "",
  });

  //filter dropdown initial value
  const [department, setDepartment] = useState([]);
  const [designation, setDesignation] = useState([]);
  const [city, setCity] = useState([]);
  const [inactive, setInactive] = useState(false);
  const [searchLoading, setSearchLoading] = useState(false);

  //searchInput
  const [searchInput, setSearchInput] = useState("");
  const [searchValue, setSearchValue] = useState({
    limit: 10,
    page: 1,
  });

  const update = useSelector((state) => state.Reports);
  const { dropDownList = {}, employee_list = {} } = update;

  const specificDispatch = useDispatch();
  const dispatch = useDispatch();
  useEffect(() => {
    specificDispatch(
      employeeListAction.loadEmployeeList({ limit: 10, page: 1 })
    );
    specificDispatch(employeeListAction.loadEmployeeDropdown());
  }, [specificDispatch]);

  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [totalCount, setTotalCount] = useState(employee_list?.count); // get this from your API response
 const designationOptions = !isEmpty(dropDownList.designationOptions)
    ? dropDownList.designationOptions.filter(item => item.departmentId === department.value)
    : [];
  useEffect(() => {
    if (employee_list) {
      setTotalCount(employee_list?.count); // total is total count of records in the backend
    }
  }, [employee_list]);

  //filter date handler
  const handleDateChange = (name, value) => {
    setEmployeeList((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  //filter reset functionality
  const onReset = () => {
    setSearchInput("");
    setSearchValue({
      limit: 10,
      page: 1,
    });
    setResetLoading(true);
    setTimeout(() => {
      setEmployeeList({
        joinFromDate: "",
        joinToDate: "",
      });
      setDepartment([]);
      setDesignation([]);
      setCity([]);
      setInactive("");
      setResetLoading(false);
    }, 1000);
    dispatch(
      employeeListAction.loadEmployeeList({
        limit: 10,
        page: 1,
      })
    );
  };

  const handleIsActiveChange = (e) => {
    if (e.target.checked) {
      setInactive(true);
    } else {
      setInactive("");
    }
  };

  //filter functionality

  const handleFilter = (e) => {
    e.preventDefault();
    setSearchLoading(true);

    setTimeout(() => {
      setSearchLoading(false);
    }, 500);
    let searchFilter = {};
    searchFilter.limit = pageSize;
    searchFilter.page = currentPage;
    if (employeeList.joinFromDate)
      searchFilter.joinDate = employeeList.joinFromDate.format("YYYY-MM-DD");
    if (employeeList.joinToDate)
      searchFilter.tojoinDate = employeeList.joinToDate.format("YYYY-MM-DD");
    if (!isEmpty(department)) searchFilter.departmentId = department.value;
    if (!isEmpty(designation)) searchFilter.designationId = designation.value;
    if (!isEmpty(city)) searchFilter.city = city.value;
    if (inactive) searchFilter.inactive = inactive;
     setSearchValue(searchFilter);

    //dispatch

    if (!isEmpty(searchFilter)) {
      dispatch(employeeListAction.loadEmployeeList(searchFilter));
    } else {
      dispatch(employeeListAction.loadEmployeeList({ limit: 10, page: 1 }));
    }
  };

  // search
  const handleSearch = () => {
    const payload = {
      search: searchInput,
    };
    setSearchLoading(true);

    setTimeout(() => {
      setSearchLoading(false);
    }, 500);
    dispatch(employeeListAction.loadEmployeeList(payload));
  };

  //download functionality
  const downloadFile = ({ data, fileName, fileType }) => {
    const blob = new Blob([data], { type: fileType });

    const a = document.createElement("a");
    a.download = fileName;
    a.href = window.URL.createObjectURL(blob);
    const clickEvt = new MouseEvent("click", {
      view: window,
      bubbles: true,
      cancelable: true,
    });
    a.dispatchEvent(clickEvt);
    a.remove();
  };

  const exportToCsv = async () => {
    setDownloadLoader(true);
    let searchFilter = {};

    if (employeeList.joinFromDate)
      searchFilter.joinDate = employeeList.joinFromDate.format("YYYY-MM-DD");
    if (employeeList.joinToDate)
      searchFilter.tojoinDate = employeeList.joinToDate.format("YYYY-MM-DD");

    if (!isEmpty(department)) searchFilter.departmentId = department;
    if (!isEmpty(designation)) searchFilter.designationId = designation;
    if (!isEmpty(city)) searchFilter.city = city;
    if (inactive) searchFilter.inactive = inactive;

    try {
      const res = await api.post("/auth/employee/getallemployee", searchFilter);
      const employees = res.data?.data || [];

      const mappedData = employees.map((data, index) => ({
        _id: data._id,
        sno: index + 1,
        employeeName: data.employeeName || "--",
        employeeCode: data.employeeCode || "--",
        mobileNumber: data.mobileNumber || "--",
        dob: data.DOB ? moment(data.DOB).format("DD/MM/YYYY") : "--",
        dateOfJoin: data.joinDate ? moment( data.joinDate).format("DD/MM/YYYY") : "--",
        gender: data.gender || "",
        city: data.city?.cityName || "",
        cityId: data.city?._id || "",
        bloodGroup: data.bloodGroup || "--",
        maritalStatus: data.maritalStatus || "",
        department: data.departmentId?.departmentName || "--",
        departmentName: data.departmentId?.departmentName || "--",
        departmentId: data.departmentId?._id || "",
        designation: data.designationId?.designationName || "--",
        designationName: data.designationId?.designationName || "--",
        designationId: data.designationId?._id || "",
        role: data.roleId?.role || "",
        roleId: data.roleId?._id || "",
        shifts: data.workShift?.shiftName || "",
        status: data.status === 1 ? "Active" : "Inactive",
        timeShift: data.timeShift || "",
        workingDays: data.workingDays || "",
        companyEmail: data.officialMail1 || "--",
        employeeType:data?.employeeTypeId?.employeeType || ""
      }));

      // Only include fields for CSV that you want:
      const headers = [
        "S.No",
        "Employee Code",
        "Employee Name",
        "DOB",
        "Department",
        "Designation",
        "Role",
        "Date of Join",
        "Gender",
        "Mobile Number",
        "Blood Group",
        "Company Email",
        "Time Shift",
        "City",
        "Marital Status",
        "Status",
      ];

      const csvRows = mappedData.map((item) => [
        item.sno,
        item.employeeCode,
        item.employeeName,
        item.dob,
        item.department,
        item.designation,
        item.role,
        item.dateOfJoin,
        item.gender,
        item.mobileNumber,
        item.bloodGroup,
        item.companyEmail,
        item.timeShift,
        item.city,
        item.maritalStatus,
        item.status,
        item.employeeType
      ]);

      const csvContent = [
        headers.join(","),
        ...csvRows.map((row) => row.join(",")),
      ].join("\n");

      downloadFile({
        data: csvContent,
        fileName: "employee_list.csv",
        fileType: "text/csv",
      });
    } catch (error) {
      if (error) {
        setDownloadLoader(false);
      }
    } finally {
      setDownloadLoader(false);
    }
  };

  //table colums

  const columns = [
    {
      title: (
        <span style={{ whiteSpace: "nowrap" }} className="poppins-txt">
          S.No
        </span>
      ),
      dataIndex: "sno",
      width: 70,
      className: "poppins-txt-lg",
      sorter: (a, b) => a.sno - b.sno,
    },
    {
      title: "Employee Code",
      dataIndex: "employeeCode",
      className: "poppins-txt-lg",
      sorter: (a, b) => a.employeeCode.localeCompare(b.employeeCode),
    },
    {
      title: "Employee Name",
      dataIndex: "employeeName",
      className: "poppins-txt-lg",
      sorter: (a, b) => a.employeeName.localeCompare(b.employeeName),
    },
    {
      title: "DOB",
      dataIndex: "dob",
      className: "poppins-txt-lg",
      sorter: (a, b) => new Date(a.dob) - new Date(b.dob),
    },
    {
      title:"EmployeeType",
      dataIndex:"employeeType",
      className: "poppins-txt-lg",
      sorter: (a, b) => a.employeeType.localeCompare(b.employeeType),
    },
    {
      title: "Department",
      dataIndex: "department",
      className: "poppins-txt-lg",
      sorter: (a, b) => a.department.localeCompare(b.department),
    },
    {
      title: "Designation",
      dataIndex: "designation",
      className: "poppins-txt-lg",
      sorter: (a, b) => a.designation.localeCompare(b.designation),
    },
    {
      title: "Role",
      dataIndex: "role",
      className: "poppins-txt-lg",
      sorter: (a, b) => a.role.localeCompare(b.role),
    },
    {
      title: "Date of Join",
      dataIndex: "dateOfJoin",
      className: "poppins-txt-lg",
      sorter: (a, b) => new Date(a.dateOfJoin) - new Date(b.dateOfJoin),
    },
    {
      title: "Gender",
      dataIndex: "gender",
      className: "poppins-txt-lg",
      sorter: (a, b) => a.gender.localeCompare(b.gender),
    },
    {
      title: "Mobile Number",
      dataIndex: "mobileNumber",
      className: "poppins-txt-lg",
      sorter: (a, b) => a.mobileNumber.localeCompare(b.mobileNumber),
    },
    {
      title: "Blood Group",
      dataIndex: "bloodGroup",
      className: "poppins-txt-lg",
      sorter: (a, b) => a.bloodGroup.localeCompare(b.bloodGroup),
    },
    {
      title: "Company Email",
      dataIndex: "companyEmail",
      className: "poppins-txt-lg",
      sorter: (a, b) => a.bloodGroup.localeCompare(b.bloodGroup),
    },
    {
      title: "Time Shift",
      dataIndex: "timeShift",
      className: "poppins-txt-lg",
      sorter: (a, b) => new Date(a.timeShift) - new Date(b.timeShift),
    },
    {
      title: "City",
      dataIndex: "city",
      className: "poppins-txt-lg",
      sorter: (a, b) => a.city.localeCompare(b.city),
    },
    {
      title: "Marital Status",
      dataIndex: "maritalStatus",
      className: "poppins-txt-lg",
      sorter: (a, b) => a.maritalStatus.localeCompare(b.maritalStatus),
    },
    {
      title: "Working Days",
      dataIndex: "workingDays",
      className: "poppins-txt-lg",
      sorter: (a, b) => new Date(a.workingDays) - new Date(b.workingDays),
    },
    {
      title: (
        <span style={{ whiteSpace: "nowrap" }} className="poppins-txt">
          Status
        </span>
      ),
      dataIndex: "status",
      width: 100,

      render: (status) => {
        const isActive = status?.toLowerCase() === "active";
        return (
          <Tag
            style={{
              backgroundColor: isActive ? "#e6f4d7" : "#fae1e1", // updated Inactive background
              color: isActive ? "#34c38f" : "#f46a6a",
              fontWeight: 500,
              width: 60,
              height: 20,
              paddingTop: "2px",
              fontSize: "11px",
              textAlign: "center",
              lineHeight: "16px",
              borderRadius: 4,
              border: "none",
              fontFamily: "Poppins",
            }}
          >
            {isActive ? "Active" : "Inactive"}
          </Tag>
        );
      },
    },
  ];

  const tableData = !isEmpty(employee_list.data)
    ? employee_list.data.map((data, index) => ({
        _id: data._id,
        sno: index + 1,
        employeeName: data.employeeName || "--",
        employeeCode: data.employeeCode || "--",
        mobileNumber: data.mobileNumber || "--",
        dob: data.DOB ? moment(data.DOB).format("DD/MM/YYYY") : "--",
        dateOfJoin:  data.joinDate ? moment(data.joinDate).format("DD/MM/YYYY") : "--",
        gender: data.gender || "",
        city: data.city?.cityName || "",
        cityId: data.city?._id || "",
        bloodGroup: data.bloodGroup || "--",
        maritalStatus: data.maritalStatus || "",
        department: data.departmentId?.departmentName || "--",
        departmentName: data.departmentId?.departmentName || "--",
        departmentId: data.departmentId?._id || "",
        designation: data.designationId?.designationName || "--",
        designationName: data.designationId?.designationName || "--",
        designationId: data.designationId?._id || "",
        role: data.roleId?.role || "",
        roleId: data.roleId?._id || "",
        shifts: data.workShift?.shiftName || "",
        status: data.status === 1 ? "Active" : "Inactive",
        timeShift: data.timeShift || "",
        workingDays: data.workingDays || "",
        companyEmail: data.officialMail1 || "--",
        employeeType:data?.employeeTypeId?.employeeType || ""
      }))
    : [];


  return (
    <React.Fragment>
      <div className="pl-5">
        <MetaTags>
          <title>Employee List | Mequals</title>
        </MetaTags>
      </div>

      <Row justify="space-between" className="mr-4">
        <Col>
          <BreadcrumbComponent title="Employee List" items={BCrumb} />
        </Col>
      </Row>  

      <div
        style={{
          background: "#ffffff",
          margin: "4px 8px 4px 8px", // top, right, bottom, left
          padding: "16px",
          borderRadius: "8px 8px 0px 0px",
        }}
      >
        <Row gutter={[16, 16]} style={{ marginTop: "2px" }}>
          <Col xs={24} sm={12} md={8} lg={6} xl={6}>
            <div className="mb-2">
              <Typography className="poppins-txt">Department</Typography>
            </div>
            <Select
              placeholder="Select department"
              allowClear
              className="custom-select"
              name="department"
              value={department}
               onChange={(value, options) => {
                  if (options) {
                    // normal selection
                    setDepartment({
                      label: options.label,
                      value: value,
                    });
                  } else {
                    // cleared selection
                    setDepartment({ label: "", value: "" });
                  }
                }}
              options={
                !isEmpty(dropDownList) ? dropDownList.departmentOptions : []
              }
              // options={departmentOptions}
              autoComplete="off"
              dropdownRender={(menu) => (
                <h1 className="option-text-font">{menu}</h1>
              )}
            />
          </Col>

          <Col xs={24} sm={12} md={8} lg={6} xl={6}>
            <div className="mb-2">
              <Typography className="poppins-txt">Designation</Typography>
            </div>
            <Select
              placeholder="Select designation"
              allowClear
              className="custom-select"
              name="designation"
              value={designation}
              options={designationOptions }
               onChange={(value, options) => {
                  if (options) {
                    // normal selection
                    setDesignation({
                      label: options.label,
                      value: value,
                    });
                  } else {
                    // cleared selection
                    setDesignation({ label: "", value: "" });
                  }
                }}
              autoComplete="off"
              dropdownRender={(menu) => (
                <h1 className="option-text-font">{menu}</h1>
              )}
            />
          </Col>

          <Col xs={24} sm={12} md={8} lg={6} xl={6}>
            <div className="mb-2">
              <Typography className="poppins-txt">City</Typography>
            </div>
            <Select
              placeholder="Select city"
              allowClear
              className="custom-select"
              name="city"
              value={city}
              options={!isEmpty(dropDownList) ? dropDownList.cityOptions : []}
               onChange={(value, options) => {
                  if (options) {
                    // normal selection
                    setCity({
                      label: options.label,
                      value: value,
                    });
                  } else {
                    // cleared selection
                    setCity({ label: "", value: "" });
                  }
                }}
              autoComplete="off"
              dropdownRender={(menu) => (
                <h1 className="option-text-font">{menu}</h1>
              )}
            />
          </Col>

          <Col xs={24} sm={12} md={8} lg={6} xl={6}>
            <div>
              <div className="mb-2">
                <Typography className="poppins-txt">Join From Date</Typography>
              </div>
              <DatePicker
                className="custom-select py-2"
                name="joinFromDate"
                value={employeeList.joinFromDate}
                onChange={(date) => handleDateChange("joinFromDate", date)}
              />
            </div>
          </Col>

          <Col xs={24} sm={12} md={8} lg={6} xl={6}>
            <div>
              <div className="mb-2">
                <Typography className="poppins-txt">Join To Date</Typography>
              </div>
              <DatePicker
                className="custom-select py-2"
                name="joinToDate"
                value={employeeList.joinToDate}
                onChange={(date) => handleDateChange("joinToDate", date)}
              />
            </div>
          </Col>

          <Col
            xs={24}
            sm={12}
            md={8}
            lg={6}
            xl={6}
            style={{ marginTop: "12px" }}
          >
            <Checkbox
              style={{ marginTop: "15px" }}
              name="inactive"
              checked={inactive}
              onChange={(e) => handleIsActiveChange(e)}
              className="poppins-txt"
              autoComplete="off"
            >
              Inactive Employees
            </Checkbox>
          </Col>
        </Row>

        <Row justify="end" style={{ marginTop: "8px" }}>
          <Col>
            <Button
              className="custom-btn"
              icon={<ReloadOutlined style={{ fontSize: "16px" }} />}
              size="middle"
              onClick={onReset}
              loading={resetLoading}
              danger
              style={{ marginRight: "12px" }}
            >
              Reset
            </Button>
            <Button
              className="custom-btn"
              type="primary"
              size="middle"
              icon={<FilterOutlined style={{ fontSize: "18px" }} />}
              htmlType="submit"
              onClick={handleFilter}
              loading={searchLoading}
            >
              Apply Filter
            </Button>
          </Col>
        </Row>
      </div>

      <div
        style={{
          background: "#ffffff",
          margin: "20px 8px 15px 8px", // top, right, bottom, left
          padding: "16px",
        }}
      >
        <Row
          justify="space-between"
          align="middle"
          style={{ marginBottom: 16 }}
        >
          <Col>
            <Input
              placeholder="Search..."
              allowClear
              style={{ width: 250, fontFamily: "Poppins" }}
              name="searchInput"
              value={searchInput}
              onChange={(e) => setSearchInput(e.target.value)}
              type="text"
              autoComplete="off"
            />

            <Button
              icon={<SearchOutlined />}
              type="primary"
              style={{ marginLeft: 8 }}
              onClick={handleSearch}
            />
          </Col>
          <Col>
            <Button
              className="custom-btn"
              size="medium"
              type="primary"
              icon={<DownloadOutlined />}
              loading={downloadLoader}
              onClick={exportToCsv}
            >
              Download
            </Button>
          </Col>
        </Row>

        <Table
          columns={columns}
          loading={searchLoading}
          dataSource={tableData}
          className="poppins-txt"
          rowKey={(record) => record._id}
          rowClassName={"text-[12px]"}
          pagination={{
            current: currentPage,
            pageSize: pageSize,
            total: totalCount,
            showSizeChanger: true,
            pageSizeOptions: ["5", "10", "20", "30"],
            showTotal: (total, range) => `${range[0]}-${range[1]} of ${total}`,
          }}
          sortDirections={["ascend", "descend"]}
          showSorterTooltip={"sorter-icon"}
          scroll={{
            x: 765,
          }}
          onChange={(pagination, filters, sorter) => {
            const { current, pageSize } = pagination;
            setCurrentPage(current); // you can manage currentPage and pageSize in your component state if needed
            setPageSize(pageSize);
            const updatedParams = {
              ...searchValue,
              page: current,
              limit: pageSize,
            };

            setSearchValue(updatedParams);
            specificDispatch(
              employeeListAction.loadEmployeeList(updatedParams)
            );
          }}
        />
      </div>
    </React.Fragment>
  );
};
//EmployeeList
export default EmployeeList;
